angular.module('app.controllers.non-paginated-forms.referral-feedback', [])
    .controller("ReferralFeedbackController", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.form_processed = "";
        $scope.form_name = "Referral Feedback";
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.commentsChars = /^[A-z0-9-'.,?\$\!\+\(\)\/\r\n ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.form_info = [
            "If you have an emergency, please do not use this form. Call 877-860-6020 if you have an emergency" +
            " or safety related issue.",
            "Please use our Online Service Request System to start, stop, or move services. Do not use this form.",
            "If you have Investor Relations Business or questions related to this, please use the Investor Relations Form.",
            "For questions about your stock account or any Shareholder Services, please call Wells Fargo Shareowner Services" +
            "at 800-331-1119, Monday-Friday from 7 a.m.-7 p.m. CT."
        ];
        $scope.success_response = [
            "Thank you for taking the time to provide us with your valuable feedback!",
            "If you included your name and number on the form then you should hear from us soon."
        ];

        // inquirylist json list of NG Inquiry Types in form widget (edit this to update on form)
        // There are two columns, IdFor must be unique on the form used in ID and FOR tag (as defined by PrimetiveLogic)
        // Be sure to alphabatize InquiryFor, IDFor is just unique sequential ID number can be changed as needed
        $scope.inquirylist = [
            { "Column": "1", "InquiryFor": "Barbeque", "fValue": "1", "IdFor": "1" },
            { "Column": "2", "InquiryFor": "Dryer", "fValue": "2", "IdFor": "2" },
            { "Column": "1", "InquiryFor": "Fire Pit", "fValue": "3", "IdFor": "3" },
            { "Column": "2", "InquiryFor": "Fireplace", "fValue": "11", "IdFor": "4" },
            { "Column": "1", "InquiryFor": "Furnace", "fValue": "4", "IdFor": "5" },
            { "Column": "2", "InquiryFor": "Garage Heater", "fValue": "9", "IdFor": "6" },
            { "Column": "1", "InquiryFor": "Gas Lights", "fValue": "5", "IdFor": "7" },
            { "Column": "2", "InquiryFor": "Gas Logs", "fValue": "7", "IdFor": "8" },
            { "Column": "1", "InquiryFor": "Gas Pac", "fValue": "8", "IdFor": "9" },
            { "Column": "2", "InquiryFor": "Generators", "fValue": "10", "IdFor": "10" },
            { "Column": "1", "InquiryFor": "Outdoor Fireplace", "fValue": "15", "IdFor": "11" },
            { "Column": "2", "InquiryFor": "Patio Heaters", "fValue": "12", "IdFor": "12" },
            { "Column": "1", "InquiryFor": "Piping", "fValue": "6", "IdFor": "13" },
            { "Column": "2", "InquiryFor": "Pool/Spa", "fValue": "14", "IdFor": "14" },
            { "Column": "1", "InquiryFor": "Range/Oven", "fValue": "13", "IdFor": "15" },
            { "Column": "2", "InquiryFor": "Tiki Torches", "fValue": "17", "IdFor": "16" },
            { "Column": "1", "InquiryFor": "Tankless Water Heater", "fValue": "18", "IdFor": "17" },
            { "Column": "2", "InquiryFor": "Water Heater", "fValue": "16", "IdFor": "18" },
            { "Column": "1", "InquiryFor": "Other", "fValue": "19", "IdFor": "19" }
        ];

        $scope.inquirySelected = { inqNumber: 0 };
        $scope.naturalGasInquiry = 0;

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
            //   alert(value);
        };

        $scope.resetForm = function () {
            //  alert (inquirySelected.inqNumber);
            //alert($scope.resetForm);
            $scope.serviceArea = "";
            $scope.applianceDealer = "";
            $scope.applianceDealerContractorName = "";
            //   $scope.inquirySelected = {inqNumber: 0};
            //$scope.naturalGasInquiry = "";
            $scope.appliance = "";
            $scope.applianceDealerOverallRating = "";
            $scope.applianceInformationOverallRating = "";
            $scope.comments = "";
            $scope.messageType = "";
            $scope.surveyContactName = "";
            $scope.surveyContactNumber = "";
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var serviceArea = $scope.serviceArea,
                    applianceDealer = $scope.applianceDealer,
                    applianceDealerContractorName = $scope.applianceDealerContractorName,
                    naturalGasInquiry = $scope.naturalGasInquiry,
                    appliance = $scope.appliance,
                    applianceDealerOverallRating = $scope.applianceDealerOverallRating,
                    applianceInformationOverallRating = $scope.applianceInformationOverallRating,
                    comments = $scope.comments,
                    messageType = $scope.messageType,
                    surveyContactName = $scope.surveyContactName,
                    surveyContactNumber = $scope.surveyContactNumber;

                $.ajax({
                    url: "/swgasws/rest/form/referralfeedback/add",
                    type: "post",
                    dataType: 'json',
                    data: {
                        serviceArea: serviceArea,
                        applianceDealer: applianceDealer,
                        applianceDealerContractorName: applianceDealerContractorName,
                        naturalGasInquiry: $scope.naturalGasInquiry,
                        appliance: appliance,
                        applianceDealerOverallRating: applianceDealerOverallRating,
                        applianceInformationOverallRating: applianceInformationOverallRating,
                        comments: comments,
                        messageType: messageType,
                        surveyContactName: surveyContactName,
                        surveyContactNumber: surveyContactNumber,
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {
                        switch (data.status) {
                            case 'success':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-good'>" + data.message + "</span> Thank you for taking the time to provide us with your valuable feedback!</p><p>If you included your name and number on the form then you should hear from us soon.</p>";
                                break;
                            case 'badrequest':
                                resp = data.toString().split("|");
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the submission problem(s). <br /> " + resp[1] + "</span></p>";
                                break;
                            case 'error':
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of the submission problem(s). <br /> </span></p>";
                                break;
                            default:  // all other errors
                                document.getElementById("responsemessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified about this problem.</span></p>";

                        }  // end switch


                        $scope.isDisabled = !0;
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Feedback has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    }
                });
            }
        };

    });